import React from "react";

import { PortfolioCard } from "@/pages/USDv/components/PortfolioCard";
import { ANIM_CSS } from "@/pages/USDv/components/stakeAnimation";
import { TradeWidget } from "@/pages/USDv/components/SwapStake";

import { PerksList } from "./components/PerksList";

/**
 * @version 1.0.0
 * @published 2026-04-08
 * @history
 *   1.0.0 — Initial publish from prototype/pages/Perks/PerksPositionsPage.tsx.
 *           Logged-in Perks page mirroring the USDv positions layout: the
 *           scrollable left column shows the portfolio card + the ways-to-earn
 *           list, and the sticky right column reuses the USDv swap/stake
 *           widget.
 */
export function PerksPositionsPage(): React.ReactElement {
    return (
        <>
            <style dangerouslySetInnerHTML={{ __html: ANIM_CSS }} />

            <div className="bg-surface-ground flex-1">
                <div className="flex gap-10 justify-center max-w-[1200px] mx-auto px-6 pt-6">
                    {/* Left: scrollable content */}
                    <div className="flex flex-col gap-10 flex-1 max-w-[604px] pb-12">
                        <div
                            style={{
                                opacity: 0,
                                animation:
                                    "page-fade-up 400ms ease-out 100ms forwards"
                            }}
                        >
                            <PortfolioCard />
                        </div>
                        <div
                            style={{
                                opacity: 0,
                                animation:
                                    "page-fade-up 400ms ease-out 300ms forwards"
                            }}
                        >
                            <PerksList showFootnote />
                        </div>
                    </div>

                    {/* Right: sticky widget */}
                    <div
                        className="sticky top-6 self-start shrink-0"
                        style={{
                            opacity: 0,
                            animation:
                                "page-fade-up 400ms ease-out 500ms forwards"
                        }}
                    >
                        <TradeWidget />
                    </div>
                </div>
            </div>
        </>
    );
}
